import './emojiPopup.js';
import '@tencent/exeditor3-ui-kit/dist/toolbar-button.js';
import { createIcon } from '@tencent/exeditor3-ui-kit/dist/icon.js';
// 默认的QQ表情配置
const defaultQQEmojiConfig = {
    key: 'qq',
    total: 173,
    size: 24,
    url: 'https://om.gtimg.cn/exeditor/emoji/qq.png',
    rowCount: 10,
};
export class EmojiPlugin {
    constructor(opt = { customEmoji: [] }) {
        this.name = 'emoji';
        // public spec: ExNodeSpec<{ xxxx: string }> = {
        this.spec = {
            type: 'node',
            inline: true,
            // 匹配 DOM 元素的 queryselector 选择器
            matchSelector: 'span[exeditor-emoji]',
            // 属性的 parse 和 toDOMAttribute
            attrs: {
                style: {
                    parse: (node) => node.getAttribute('style') || node.textContent || '',
                    toDOMAttribute: (style) => ({ style }),
                },
                type: {
                    parse: (node) => node.getAttribute('exeditor-emoji') || '',
                    toDOMAttribute: (type) => ({ type }),
                },
            },
            // 输出的元素标签
            toDOM: (_node, attr) => {
                return {
                    tag: 'span',
                    attributes: {
                        'exeditor-emoji': attr.type,
                        style: attr.type === 'native' ? undefined : attr.style,
                    },
                    children: attr.type === 'native' ? attr.style : undefined,
                };
            },
        };
        this.renderAndGetEmojiPopup = () => {
            // 执行两遍?，加个拦截
            const oldPopup = document.querySelector('exeditor-emoji-popup');
            if (oldPopup) {
                return oldPopup;
            }
            const popup = document.createElement('exeditor-emoji-popup');
            return popup;
        };
        this.emojiSelect = (event) => {
            this.editor
                .selection()
                .replaceWithNode(this, {
                style: event.detail.value,
                type: event.detail.key,
            });
        };
        this.preLoad = (imgList) => {
            imgList.forEach((img) => {
                const preImg = new Image();
                preImg.src = img;
            });
        };
        this.opt = {
            ...opt,
            customEmoji: [defaultQQEmojiConfig].concat(opt.customEmoji || []),
        };
    }
    // 初始化
    initEditor(editor) {
        this.editor = editor;
    }
    capabilities() {
        return {
            // 定义操作
            commands: {},
            // 定义快捷键
            shortcuts: {},
        };
    }
    // 自定义菜单按钮
    renderToolbarItem() {
        var _a;
        this.preLoad((_a = this.opt.customEmoji) === null || _a === void 0 ? void 0 : _a.map((emoji) => emoji.url));
        const btn = document.createElement('exeditor-toolbar-button');
        btn.label = this.editor.t('表情符号');
        const icon = createIcon({
            name: this.name,
            editor: this.editor,
            fallback: () => import('./icon.js').then((m) => m.icon),
        });
        const emojiDialog = this.renderAndGetEmojiPopup();
        emojiDialog.customEmoji = this.opt
            .customEmoji;
        emojiDialog.target = btn;
        emojiDialog.nativeEmojiUrl = this.opt.nativeEmojiUrl;
        emojiDialog.addEventListener('exeditor-emoji-select', this.emojiSelect);
        btn.append(icon, emojiDialog);
        btn.addEventListener('click', () => {
            emojiDialog.show = !emojiDialog.show;
        });
        return btn;
    }
}
//# sourceMappingURL=index.js.map